module.exports = __webpack_public_path__ + "img/右哼哼.e21be5b9.png";